/**
 * Created by neo on 30.12.22.
 */
import * as React from 'react';
import { observer } from 'mobx-react';
import { useEffect } from 'react';
import ReactMarkdown, { type Components, type UrlTransform } from 'react-markdown';

export type MarkdownRendererProps = {
  text?: string | null;
  variant?: string;
  components?: Components;
  urlTransform?: UrlTransform;
};

export const MarkdownRenderer: React.FC<MarkdownRendererProps> = observer(({ text, components, urlTransform }) => {
  return (
    <ReactMarkdown components={components} urlTransform={urlTransform}>
      {text ?? ''}
    </ReactMarkdown>
  );
});
